.card {
  max-width: 270px;
  background: #f5f5f5;
  border-radius: 20px;
  corner-shape: superellipse(1.18);
  border: 1px solid #ded7cf;
  padding: 36px 28px 32px;
  text-align: center;
  box-sizing: border-box;
}

.scoreRow {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 12px;
}

.scoreValue {
  font-size: 56px;
  font-weight: 300;
  letter-spacing: 0.04em;
}

.scoreMax {
  font-size: 32px;
  font-weight: 500;
}

.starsRow {
  margin-bottom: 20px;
}

.text {
  margin: 0 0 26px;
  font-size: 14px;
  line-height: 1.5;
  color: #505050;
}

.learnMoreButton {
  border-radius: 999px;
  border: 1px solid #111111;
  background: transparent;
  font-size: 14px;
  font-weight: 400;
  padding: 9px 18px;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;
}

.learnMoreButton:hover {
  background: #111111;
  color: #fffdf7;
}
